import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHereComponent } from './simple-icons-here.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHereComponent ],
    exports:      [ SimpleIconsHereComponent ],
    bootstrap:    []
})
export class SimpleIconsHereModule {}
